import { mapSpotCssVariables } from "@gettactic/components/themes/mapSpotColors";
import base from "./base";
import { themes } from "./index";

export interface ITheme {
  [key: string]: any;
}
export interface IThemes {
  [key: string]: ITheme;
}
export interface IMappedTheme {
  [key: string]: string | null;
}

export const mapTheme = (variables: ITheme): IMappedTheme => {
  return {
    // ---------------------
    // Primary Colors
    // ---------------------
    "--color-primary": variables?.primary.DEFAULT || base.primary.DEFAULT,
    "--color-primary-text": variables?.primary.text || base.primary.text,
    "--color-primary-bg": variables?.primary.bg || base.primary.bg,
    "--color-primary-hover": variables?.primary.hover || base.primary.hover,
    "--color-primary-lighter":
      variables?.primary.lighter || base.primary.lighter,
    "--color-primary-darker": variables?.primary.darker || base.primary.darker,
    // ---------------------
    // Tertiary Colors
    // ---------------------
    "--color-tertiary": variables?.tertiary.DEFAULT || base.tertiary.DEFAULT,
    "--color-tertiary-text": variables?.tertiary.text || base.tertiary.text,
    "--color-tertiary-bg": variables?.tertiary.bg || base.tertiary.bg,
    "--color-tertiary-hover": variables?.tertiary.hover || base.tertiary.hover,
    // ---------------------
    // Secondary Colors
    // ---------------------
    "--color-secondary": variables?.secondary.DEFAULT || base.secondary.DEFAULT,
    "--color-secondary-bg": variables?.secondary.bg || base.secondary.bg,
    "--color-secondary-text": variables?.secondary.text || base.secondary.text,
    "--color-secondary-hover":
      variables?.secondary.hover || base.secondary.hover,
    // ---------------------
    // General Colors
    // ---------------------
    "--color-brand": variables?.brand || base.brand,
    "--color-highlight": variables?.highlight || base.highlight,
    "--color-disabled": base.disabled,
    "--color-event-past": base.event.past.DEFAULT,
    "--color-hyperlink": variables?.hyperlink || base.hyperlink,
    "--color-input": variables?.input || base.input,
    "--color-background": variables?.background || base.background,
    "--color-overlay": variables?.overlay || base.overlay,
    // ---------------------
    // Status Colors
    // ---------------------
    "--color-success": variables?.success?.DEFAULT || base.success.DEFAULT,
    "--color-success-text": variables?.success?.text || base.success.text,
    "--color-success-bg": variables?.success?.bg || base.success.bg,
    // '--color-warning': variables?.warning?.DEFAULT || base.warning.DEFAULT,
    "--color-error": variables?.error?.DEFAULT || base.error.DEFAULT,
    "--color-error-text": variables?.error?.text || base.error.text,
    "--color-error-bg": variables?.error?.bg || base.error.bg,

    // ---------------------
    // Map Colors
    // ---------------------

    ...mapSpotCssVariables(variables?.map, base.map)
  };
};

export const applyTheme = (theme: string): void => {
  // In v2, themes are applied via CSS variables in the theme system
  // This function is kept for backward compatibility but does nothing
  return;
};

export const extend = (extending: ITheme, newTheme: ITheme): ITheme => {
  return { ...extending, ...newTheme };
};
